import type {FC} from 'react';

export const BuyerFatcaCrsSupplementarySkeleton: FC = () => (
  <div className="flex flex-col gap-6" aria-busy="true">
    <div className="h-24 rounded-xl bg-background-secondary" />
    <div className="h-40 rounded-xl bg-background-secondary" />
    <div className="h-24 rounded-xl bg-background-secondary" />
  </div>
);
